import React, { useContext, useEffect, useState } from 'react';
import Navigation from './components/navigation/Navigation';
import { AppContext, UserContext } from './AppContextProvider';
import { VitrineContext } from './components/vitrines/VitrineContext';
import {isMobile, MobileView } from 'react-device-detect';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from './components/user/login/Login';
import {
  useWindowSize,
} from '@react-hook/window-size'
import Footer from './components/navigation/Footer';
import Authentification from './components/user/login/Authentification';
import Vitrines from './components/vitrines/Vitrines';
import User from './components/user/User';
import AjoutArticle from './components/produit/ajout-article/AjoutArticle';
import PromoForm from './components/produit/promo/PromoForm';
import Produit from './components/produit/Produit';
 import Conversations from './components/user/messagerie/Conversations';
import Charges from './components/vitrines/filtres/photovoltaique/Charges';
import Learning from './components/chatbot/learning/Learning';
import PaymentResult from './components/user/panier/payment/Result';
import Order from './components/user/orders/Order';
import Messagerie from './components/user/messagerie/Messagerie';
import { v4 as uuidv4 } from 'uuid';
import CG from './components/cgu/CG';
//import PositionSharing from './components/api/WsPositionSharing';
//import WsNotifications from './components/api/WsNotifications';

if (isMobile)
  import('./m_app.css').then(() => {});
else
  import('./app.css').then(() => {});


export default function App()
{             
    const AppState = useContext(AppContext);
    const UserState = useContext(UserContext);
    const [_AppState,_setAppState] = useState(AppState);
    const [_UserState,_setUserState] = useState(UserState);
    const [width,height] = useWindowSize();
    const _vitrines = useContext(VitrineContext);
    const [vitrines,setVitrines] = useState(_vitrines);

    let PageTopPosition = '85px';
    if(isMobile)
      PageTopPosition = '75px';

    useEffect(()=>{
        let _settings = localStorage.getItem('settings');
        if(!!_settings)
        {
            _settings = JSON.parse(_settings);
            _setAppState({..._AppState,settings:_settings})
        };
      },[])
    
      return (
        <AppContext.Provider value={[_AppState, _setAppState]}>
          <UserContext.Provider value={[_UserState, _setUserState]}>
            <VitrineContext.Provider value={[vitrines, setVitrines]} >
                <div className="App" style={{width:width+'px',minHeight:height+'px'}}>
                    <Router >
                      <Navigation MobileNavBtnLClick={_AppState.MobileNavBtnLClick} />
                      <div id='Page' style={{position:'relative',top:PageTopPosition}}>
                        <Routes>
                            <Route path='/' element={<Vitrines />} />
                            {
                              ['/authentication/','/authentication/:form','/authentication/:form/:params'].map((path,index)=>
                                  <Route path={path} element={<Authentification />} key={index} />   
                              )
                            }
                                                {
                              ['/login/','/login/:form','/login/:form/:params'].map((path,index)=>
                                  <Route path={path} element={<Login />} key={index} />   
                              )
                            }                            
                            { 
                              ['/user/','/user/:menu/','/user/:menu/:param'].map((path,index)=>
                                  <Route path={path} element={<User />} key={index} />   
                              )
                            }
                            {
                              ['/add-product/','/add-product/:id/'].map((path,index)=>
                                  <Route path={path} element={<AjoutArticle />} key={index} />   
                              )
                            }
                            <Route path='/payment/result/:status/:id/' element={<PaymentResult />} />
                            <Route path='/order/object/:id/' element={<Order />} />
                            <Route path='/photovoltaique/sizing/' element={<Charges />} />
                            <Route path={'/product/:id/'} element={<Produit  />} />
                            <Route path={'/learning/:target/:id/'} element={<Learning  />} />
                            <Route path={'/conversations/:role/:order/'} element={<Conversations  />} />
                            <Route path={'/conversation/:number/'} element={<Messagerie  />} />
                            <Route path={'/promos/'} element={<PromoForm  />} />
                            <Route path={'/about/'} element={
                                <div style={{backgroundColor:'white',padding:'20px',width:'50%',margin:'auto',textAlign:'center'}}>
                                  <CG display_close_button={false}/>
                                </div>
                              } />
                        </Routes>
                      </div>
                        <MobileView>
                          <Footer histogram={vitrines.histogram}/>
                        </MobileView>
                    </Router>
                </div>
            </VitrineContext.Provider>
          </UserContext.Provider>
        </AppContext.Provider>
        );
   }



